class exports.PlantingPlanHybrid

    id: null
    fieldID: null
    hybridID: null
    hybridName: ''
    treatmentID: null
    treatmentName: ''
    units: 0

    constructor: (hybrid, id = null) ->
        if not (hybrid? and hybrid instanceof Object)
            return @error 'No hybrid given.', hybrid

        if id? and parseInt id
            @id = parseInt id
            # basically, if a planting plan ID is given as a parameter, then
            # hybrid.id might be the hybrid ID, not the planting plan ID
            if hybrid.id? and not hybrid.hybridID?
                hybrid.hybridID = hybrid.id
        else if hybrid.id? and parseInt hybrid.id
            @id = parseInt hybrid.id
        else
            return @error 'No planting plan ID given.', hybrid

        if hybrid.fieldID? and parseInt hybrid.fieldID
            @fieldID = parseInt hybrid.fieldID
        else
            return @error 'No field ID given.', hybrid

        if hybrid.hybridID? and parseInt hybrid.hybridID
            @hybridID = parseInt hybrid.hybridID
        else
            return @error 'No hybrid ID given.', hybrid

        if hybrid.hybridName?
            @hybridName = hybrid.hybridName
        else if hybrid.hybrids_name
            @hybridName = hybrid.hybrids_name
        else
            return @error 'No hybrid name given.', hybrid

        if hybrid.treatmentID? and parseInt hybrid.treatmentID
            @treatmentID = parseInt hybrid.treatmentID
        else if hybrid.treatments_id?
            @treatmentID = parseInt hybrid.treatments_id

        if hybrid.treatmentName?
            @treatmentName = hybrid.treatmentName
        else if hybrid.treatments_name?
            @treatmentName = hybrid.treatments_name
        else if @treatmentID?
            return @error 'No treatment name given.', hybrid

        if hybrid.units? and parseInt hybrid.units
            @units = parseInt hybrid.units
        else
            return @error 'No units given.', hybrid

        @displayName = @hybridName + (if @treatmentID? then ' w/ ' + @treatmentName else '')


    get: () ->
        obj =
            id: @id
            fieldID: @fieldID
            hybridID: @hybridID
            hybridName: @hybridName
            treatmentID: @treatmentID
            treatmentName: @treatmentName
            displayName: @displayName
            units: @units
        return obj


    getHybrid: () ->
        obj =
            id: @hybridID
            hybridName: @hybridName
            treatmentID: @treatmentID
            treatmentName: @treatmentName
            displayName: @displayName
        return obj


    error: (msg, obj = null) ->
        debugLog 'Failed to create PlantingPlanHybrid object. ' + msg
        debugLog obj if obj?
        return null
